export class SkyModalCloseArgs {
  public reason: string;
  public data: any;
  constructor() {}
}
